import Header from "./header";
import Body from "./body";
import Root from "./root";

const Popover = {
    Root,
    Header,
    Body,
};

export default Popover;
